import post1 from "../images/post1.png";
import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import blogData from "./Blogs/data";
import Templates from "./Blogs/TemplateData";
import classes from "../components/Post.module.css";
import Button from "../components/Button";

function Post() {
  const { page } = useParams();

  //const slugify = (pageNumber) => pageNumber.replace("1");
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const postsPerPage = 3;

  const TemplatePosts = Templates.filter(
    (post) =>
      post.Intro.toLowerCase().includes(searchQuery.toLowerCase()) ||
      post.FrontHeading.toLowerCase().includes(searchQuery.toLowerCase()) ||
      post.author.toLowerCase().includes(searchQuery.toLowerCase())
  ); //.sort((a, b) => b.id - a.id);

  const BlogPost = blogData.filter(
    (post) =>
      post.Intro.toLowerCase().includes(searchQuery.toLowerCase()) ||
      post.FrontHeading.toLowerCase().includes(searchQuery.toLowerCase()) ||
      post.author.toLowerCase().includes(searchQuery.toLowerCase())
  );
  //.sort((a, b) => b.id - a.id);

  //Merge both sources into one
  const allPosts = [...TemplatePosts, ...BlogPost]
    .filter((p) => p.Active)
    .sort((a, b) => b.id - a.id);

  const totalPages = Math.ceil(allPosts.length / postsPerPage);
  const startIndex = (currentPage - 1) * postsPerPage;
  const endIndex = startIndex + postsPerPage;
  const currentPosts = allPosts.slice(startIndex, endIndex);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  function PostCard({ post }) {
    return (
      <div className="card mb-3 shadow-sm rounded-0 border-0 overflow-hidden p-3">
        <div className="row">
          {/* Image */}
          <div className="col-4">
            {post.imgSrc && (
              <img
                src={post.imgSrc}
                className="img-fluid h-100 w-100 object-fit-cover"
                alt="blog cover"
              />
            )}
          </div>

          {/* Content */}
          <div className={`col-md-7 ${classes.post}`}>
            <div className="card-body d-flex flex-column justify-content-between h-100">
              {/* Author */}
              <div className="d-flex align-items-center mb-3">
                <div
                  className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center"
                  style={{ width: "40px", height: "40px" }}
                >
                  {post.author.charAt(0)}
                </div>
                <div className="ms-2" style={{ color: "#113358" }}>
                  <div className="fw-semibold">{post.author}</div>
                  <div>
                    {post.date} • {post.readTime}
                  </div>
                </div>
              </div>

              {/* Title */}
              <h5 className="fw-bold">{post.FrontHeading}</h5>

              {/* Description */}
              <p className="card-text text-muted">{post.Intro}</p>

              <Button
                name="Read more"
                link={`/Article/${post.title
                  .replace(/\s+/g, "-")
                  .toLowerCase()}`}
                className="btn btn-primary rounded-pill px-4 align-self-start"
              >
                Read more
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="row mb-4">
        <input
          type="text"
          className="form-control px-3 py-2"
          placeholder="Search blogs..."
          value={searchQuery}
          onChange={(e) => {
            setSearchQuery(e.target.value);
            setCurrentPage(1); // reset to first page on search
          }}
        />
      </div>
      <div className="row">
        {currentPosts.length > 0 ? (
          currentPosts.map((post, index) => (
            <>
              <PostCard key={index} post={post} />
            </>
          ))
        ) : (
          <p>No post found</p>
        )}
      </div>

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="d-flex justify-content-center mt-4">
          <nav>
            <ul className="pagination">
              {[...Array(totalPages)].map((_, index) => (
                <li
                  key={index}
                  className={`page-item ${
                    currentPage === index + 1 ? "active" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => handlePageChange(index + 1)}
                  >
                    {index + 1}
                  </button>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      )}
    </>
  );
}

export default Post;
